let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("75s81")).then(() => parcelRequire('6T3Ce'));